// Globální jQuery reference na hlavní prvky layoutu
/** @type {jQuery} Hlavní element hlavičky webu */
var $header = $("header.site-header");
/** @type {jQuery} Hlavní element patičky webu */
var $footer = $("footer.site-footer");
/** @type {jQuery} Tlačítko pro otevření mobilní navigace */
var $menuBtn = $header.find(".site-header__menu-btn")
/** @type {jQuery} Wrapper mobilní navigace */
var $mobileNav = $header.find(".site-header__nav-wrapper");
/** @type {jQuery} Průhledný overlay překrývající obsah při otevřené navigaci/vyhledávání */
var $clickPlaceholder = $(".click-body-placeholder");
/** @type {jQuery} Vyhledávací pole v hlavičce */
var $headerSearch = $(".header__search");
/** @type {number} Breakpoint (px) pod nímž se zobrazuje mobilní navigace */
var $hideNavBreakpoint = 890;

/**
 * Otevře mobilní navigaci – přidá třídu 'active' tlačítku, nav wrapperu a overlay placeholderu.
 *
 * @returns {void}
 */
function openNav() {
    $header.addClass("active");
    $menuBtn.addClass("active");
    $mobileNav.addClass("active");
    $clickPlaceholder.addClass("active");
}

/**
 * Zavře mobilní navigaci – odebere třídu 'active' tlačítku, nav wrapperu a overlay placeholderu.
 *
 * @returns {void}
 */
function hideNav() {
    $header.removeClass("active");
    $menuBtn.removeClass("active");
    $mobileNav.removeClass("active");
    $clickPlaceholder.removeClass("active");
}

/**
 * Nastaví CSS custom properties pro výšku hlavičky, patičky a minimální výšku hlavního obsahu.
 * Volá se při načtení stránky a při každém resize okna.
 * Hodnoty jsou dostupné v CSS jako: var(--header--height), var(--footer--height), var(--main-min-height)
 *
 * @returns {void}
 */
const generateCSSVars = () => {
    const doc = document.documentElement
    doc.style.setProperty('--header--height', $header.innerHeight()+"px");
    doc.style.setProperty('--footer--height', $footer.innerHeight()+"px");
    doc.style.setProperty('--main-min-height', ($(window).innerHeight() - $("footer.footer").innerHeight() - $("#wpadminbar").innerHeight())+"px");
}
window.addEventListener('resize', generateCSSVars)
generateCSSVars();

/**
 * Zkopíruje aktuální URL stránky do schránky.
 * Po úspěšném zkopírování přidá tlačítku třídu 'ok' na 1 sekundu (vizuální potvrzení).
 * Používá se ve sdílecím tlačítku komponenty sharing-buttons.
 *
 * @param {HTMLElement} button - Tlačítko, které bylo kliknuto
 * @returns {void}
 */
function copyCurrentUrl(button) {
	const url = window.location.href;
	navigator.clipboard.writeText(url).then(() => {
        button.classList.add('ok');

        setTimeout(() => {
			button.classList.remove('ok');
		}, 1000);
	}).catch(err => {
		console.error('Kopírování se nezdařilo:', err);
		alert('Nepodařilo se zkopírovat odkaz.');
	});
}

// Lenis smooth scroll – inicializace před DOM ready aby RAF loop běžel co nejdřív
if (typeof Lenis !== 'undefined') {
    window.lenis = new Lenis({
        duration: 1.2,
        easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smooth: true
    });

    function lenisRaf(time) {
        window.lenis.raf(time);
        requestAnimationFrame(lenisRaf);
    }

    requestAnimationFrame(lenisRaf);
}

// Animace načtení hlavičky — přidá třídu loaded po 100 ms
setTimeout(() => {
    $header.addClass("loaded");
}, 100);

// Třída scrolled pro ztmavení hlavičky při scrollu
$(document).scroll(function () {
    if ($(this).scrollTop() > 0) {
        $header.addClass("scrolled");
    } else {
        $header.removeClass("scrolled");
    }
});

$(document).ready(function () {

    if (typeof Fancybox !== "undefined" && typeof Fancybox.bind === "function") {
        Fancybox.bind("[data-fancybox]", {
            Hash: false, // Zakáže přidávání # do URL
            l10n:  Fancybox.l10n.cs_CZ,
        });
    }

    /** Plynulý scroll na kotvu – Lenis nebo jQuery fallback */
    if (typeof Lenis !== 'undefined' && window.lenis) {
        document.querySelectorAll("a[href^='#'], a[href^='/#']").forEach(function(link) {
            link.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                const id = href.replace(/^\/?#/, '');
                const target = document.getElementById(id);
                if (target) {
                    e.preventDefault();
                    window.lenis.scrollTo(target);
                }
            });
        });
    } else {
        $("a[href^='#'], body.home a[href^='/#']").click(function(e) {
            e.preventDefault();
            var target = this.hash, $target = $(target);
            if ($target.length) {
                $("html, body").stop().animate({
                    "scrollTop": $target.offset().top - $header.innerHeight() - 40
                }, 400, "swing");
            }
        });
    }
    
    /** Kliknutí na tlačítko menu */
    $menuBtn.click(function (e) { 
        e.preventDefault();
        if($(this).hasClass("active")) {
            hideNav();
        }else {
            openNav();
        }
    });

    /** Kliknutní na placeholder menu */
    $clickPlaceholder.click(function (e) { 
        e.preventDefault();
        if($menuBtn.hasClass("active")) {
            hideNav();
        }else {
            if($(window).innerWidth() <= $menuBtn) {
                openNav();
            }
        }

        if($headerSearch.hasClass("active")) {
            $headerSearch.removeClass("active");
            $(this).removeClass("active");
        }
    });

    /** Otevření / Zavření vyhledávání v hlavičce */
    $headerSearch.find("button").click(function (e) { 
        if($headerSearch.hasClass("active")) {
            if($headerSearch.find("input[name='s']").val() == "") {
                e.preventDefault();
                $headerSearch.removeClass("active");
                $clickPlaceholder.removeClass("active");
            }
        }else {
            e.preventDefault();
            $headerSearch.addClass("active");
            $clickPlaceholder.addClass("active");
        }
    }); 

    /** Update proměné s mezerou mezi viewportem a containerem na resize okna */
    getSpaceBetweenBasicContainerAndVieport();
    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(getSpaceBetweenBasicContainerAndVieport, 100);
    });

});

/**
 * Generický load more handler – načte další příspěvky přes AJAX a připojí je do kontejneru.
 * Aktivuje se kliknutím na element s atributem [data-load-more].
 *
 * Povinné atributy na tlačítku:
 *   data-load-more="<CSS selektor cílového kontejneru>"
 *   data-post-type="post"
 *   data-page="2"
 *   data-template="template-parts/components/post-card"
 *
 * Volitelné atributy:
 *   data-per-page="9"
 *   data-taxonomy="category"
 *   data-term="5"
 *   data-orderby="date"
 *   data-order="DESC"
 *
 * Během načítání má tlačítko třídu 'loading'. Pokud nejsou další stránky, tlačítko se odstraní.
 *
 * @returns {void}
 */
$(document).on('click', '[data-load-more]', function () {
    var $btn = $(this);

    if ($btn.hasClass('loading')) return;
    $btn.addClass('loading');

    var target   = $btn.data('load-more');
    var page     = parseInt($btn.data('page')) || 2;
    var ajaxUrl  = (typeof themeData !== 'undefined') ? themeData.ajaxUrl : '/wp-admin/admin-ajax.php';

    $.ajax({
        type: 'GET',
        url: ajaxUrl,
        data: {
            action:    'load_more_posts',
            post_type: $btn.data('post-type') || 'post',
            paged:     page,
            per_page:  $btn.data('per-page')  || 9,
            taxonomy:  $btn.data('taxonomy')  || '',
            term:      $btn.data('term')       || 0,
            template:  $btn.data('template')  || '',
            orderby:   $btn.data('orderby')   || 'date',
            order:     $btn.data('order')      || 'DESC',
        },
        success: function (response) {
            $btn.removeClass('loading');
            if (response[0] === 'ok') {
                $(target).append(response[1]);
                if (response[2] > 0) {
                    $btn.data('page', response[2]);
                } else {
                    $btn.remove();
                }
            }
        },
        error: function () {
            $btn.removeClass('loading');
        }
    });
});

/**
 * Vypočítá a nastaví CSS custom property --section-padding-from-left.
 * Hodnota odpovídá vzdálenosti mezi levým okrajem viewportu a levým okrajem .container elementu v patičce.
 * Používá se pro full-bleed sekce a nekonečné slidery, které potřebují přesáhnout kontejner.
 *
 * @returns {void}
 */
function getSpaceBetweenBasicContainerAndVieport() {
  var $container = $('.site-footer .container');

  if ($container.length) {
    var paddingLeft = $container.offset().left;

    document.documentElement.style.setProperty('--section-padding-from-left', paddingLeft + 'px');
  }
}

/**
 * Inicializuje GSAP ScrollTrigger animace pro sekce stránky.
 * Každé sekci a patičce přidá třídu 'section--in-view' při vstupu do viewportu
 * a odebere ji při vyrolování zpět nahoru.
 * Vyžaduje načtené knihovny gsap a ScrollTrigger.
 *
 * @returns {void}
 */
function initScrollAnimations() {
  gsap.utils.toArray(".section, .site-footer").forEach((section, index, sections) => {
    ScrollTrigger.create({
      trigger: section,
      start: "top 70%",
        onEnter: () => {
            section.classList.add("section--in-view");
        },
        onLeaveBack: () => {
            section.classList.remove("section--in-view");
        }
    });
  });
}